import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Countries from '../components/countries';
import Languages from '../components/supportedLanguages';
import functionsApi from '../api';

const styles = (theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(3)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	progess: {
		position: 'absolute'
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	pagelink: {
		color: 'blue'
	}
});

class signup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: '',
			certification: '',
			phoneNumber: '',
			country: '',
			email: '',
			password: '',
			confirmPassword: '',
			socialNetworks: [],
			spokenLanguages: [],
			errors: [],
			contents:[],
			loading: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.UI.errors) {
			this.setState({
				errors: nextProps.UI.errors
			});
		}
	}

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleCountryChange = (event) => {
		this.setState({
			country: event
		});
	};

	handleLanguageChange = (event) => {
		
		const items = []

		for (const [index, value] of event.entries()) {
			if(typeof this.state.contents[index] === 'undefined') {
				items.push({id: index, language: value.code, languageDescription: value.label, bio: value.bio})
			} else {
				var bio = this.state.contents[index].bio
				items.push({id: index, language: value.code, languageDescription: value.label, bio: bio})
			}
		}

		this.setState({
			contents: items,
			spokenLanguages: event
		});
	};

	handleInstagramChange = (event) => {
		this.setState({
			socialNetworks: [{'type':'instagram', 'url': event.target.value}]
		});
	};

	handleContentsChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];
		
		item.bio = event.target.value
		items[event.target.id] = item
		
		this.setState({
			contents: items
		});
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ loading: true });
		const newUserData = {
			name: this.state.name,
			certification: this.state.certification,
			phoneNumber: this.state.phoneNumber,
			country: this.state.country,
			email: this.state.email,
			password: this.state.password,
			confirmPassword: this.state.confirmPassword,
			socialNetworks: this.state.socialNetworks,
			spokenLanguages: this.state.spokenLanguages,
			contents: this.state.contents
		};

		functionsApi
			.post('/signUpTrainer', newUserData)
			.then((response) => {
				localStorage.setItem('CustomToken', `${response.data.customToken}`);
				this.setState({ 
					loading: false,
				});	
				this.props.history.push('/');
			})
			.catch((error) => {
				this.setState({
					signupError: error.response.data.general,
					loading: false
				});
			});
	};

	isContentEmpty() {
		var found = false;	
		for (const [index, value] of this.state.contents.entries()) {
			if (!value.bio) {
				found = true;
			}
		}
		return found
	}

	render() {

		const { classes } = this.props;
		const { errors, loading } = this.state;
		return (
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<div className={classes.paper}>
					<Avatar src = "/static/images/new-logo.svg"></Avatar>
					<Typography component="h1" variant="h5">
						Sign up
					</Typography>

					{this.state.signupError && (
						<Typography variant="body2" className={classes.customError}>
							{this.state.signupError}
						</Typography>
					)}

					<form className={classes.form} noValidate>
						<Grid container spacing={2}>
							 <Grid item xs={12} sm={6}>
								<TextField
									variant="outlined"
									required
									fullWidth
									id="name"
									label="Name"
									name="name"
									autoComplete="name"
									helperText={errors.name}
									error={errors.name ? true : false}
									onChange={this.handleChange}
								/>
							 </Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									variant="outlined"
									required
									fullWidth
									id="email"
									label="Email Address"
									name="email"
									autoComplete="email"
									helperText={errors.email}
									error={errors.email ? true : false}
									onChange={this.handleChange}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									variant="outlined"
									required
									fullWidth
									id="phoneNumber"
									label="Phone Number"
									name="phoneNumber"
									autoComplete="phoneNumber"
									pattern="[7-9]{1}[0-9]{9}"
									helperText={errors.phoneNumber}
									error={errors.phoneNumber ? true : false}
									onChange={this.handleChange}
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									variant="outlined"
									required
									fullWidth
									id="certification"
									label="Certification"
									name="certification"
									autoComplete="certification"
									helperText={errors.certification}
									error={errors.certification ? true : false}
									onChange={this.handleChange}
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									variant="outlined"
									required
									fullWidth
									id="instagram"
									label="Instagram Profile Link"
									name="instagram"
									autoComplete="instagram"
									helperText={errors.instagram}
									error={errors.instagram ? true : false}
									onChange={this.handleInstagramChange}
								/>
							</Grid>

							<Grid item xs={12}>
								<Countries
									variant="outlined"
									required
									fullWidth
									id="country"
									label="Country"
									name="country"
									autoComplete="country"
									helperText={errors.country}
									error={errors.country ? true : false}
									onChange={this.handleCountryChange}
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									variant="outlined"
									required
									fullWidth
									name="password"
									label="Password"
									type="password"
									id="password"
									autoComplete="current-password"
									helperText={errors.password}
									error={errors.password ? true : false}
									onChange={this.handleChange}
								/>
							</Grid>
							<Grid item xs={12}>
								<TextField
									variant="outlined"
									required
									fullWidth
									name="confirmPassword"
									label="Confirm Password"
									type="password"
									id="confirmPassword"
									autoComplete="current-password"
									onChange={this.handleChange}
								/>
							</Grid>

							<Grid item xs={12}>
								<Languages
									variant="outlined"
									required
									fullWidth
									id="languages"
									label="Select the languages you speak"
									name="languages"
									autoComplete="languages"
									helperText={errors.spokenLanguages}
									error={errors.spokenLanguages ? true : false}
									onChange={this.handleLanguageChange}
								/>
							</Grid>


								{this.state.contents.map((contents) => (
									<Grid item xs={12}>
										<TextField
											variant="outlined"
											required
											fullWidth
											name={contents.language}
											multiline
											rows={4}
											label={contents.languageDescription + ' bio'}
											type="contents"
											id={contents.id}
											autoComplete="contents"
											helperText={errors.contents}
											error={errors.contents ? true : false}
											onChange={this.handleContentsChange}
										/>
									</Grid>
								))}

						</Grid>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							onClick={this.handleSubmit}
                            disabled={loading || 
                                 !this.state.email || 
								 !this.state.password ||
								 !this.state.confirmPassword ||
                                !this.state.name || 
                                !this.state.certification ||
                                !this.state.country || 
								!(this.state.socialNetworks && this.state.socialNetworks.length > 0) ||
								!(this.state.spokenLanguages && this.state.spokenLanguages.length > 0) ||
								!(this.state.contents && this.state.contents.length > 0) ||
								!this.state.phoneNumber || 
								this.isContentEmpty() 
							}
						>
							Sign Up
							{loading && <CircularProgress size={30} className={classes.progess} />}
						</Button>

						<Grid container justify="flex-start">
							<Grid item>Already have an account? 
								<Link href="login" variant="body2" className={classes.pagelink}> Sign in
								</Link>
							</Grid>
						</Grid> 

						<Grid container justify="flex-start">
							<Grid item>By creating an account you agree to 
								<Link href="https://hiitandtabata.com/terms-of-use/" variant="body2" target="_blank" rel="noopener" className={classes.pagelink} container justify="flex-start"> Hiit and Tabata's Terms of Use
								</Link>
							</Grid>
						</Grid> 

					</form>
				</div>
			</Container>
		);
	}
}

export default withStyles(styles)(signup);
